import { ReactComponent as Logo } from "src/images/logo.svg";
import styled, { css } from "styled-components";
import { media } from "../../styles/mixins";

export const StyledHeader = styled.header<{ navOpened: boolean }>`
  width: 100%;
  height: var(--nav-height);
  background-color: ${({ theme }) => theme.colors.background};
  overflow: visible;
  z-index: 203;
  border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
  transition: height 0.3s cubic-bezier(0, 0, 0.2, 1);

  position: absolute;
  top: 0;

  @media (max-width: 1024px) {
    ${({ navOpened }) =>
      navOpened &&
      css`
        height: 100vh;
        transition: height 0.3s cubic-bezier(0.4, 0, 1, 1);
      `}
    overflow: hidden;
    z-index: 1000;
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
  }
`;

export const HeaderWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template: 100% / auto auto;
  align-items: center;
  /* padding: 0 var(--nav-padding); */

  > a {
    display: inline-block;
    justify-self: start;
    max-height: 37.8px;
    height: 70%;
    grid-column: 1/2;
    grid-row: 1/2;
  }

  @media (max-width: 1024px) {
    height: calc(100% - var(--nav-height));
    grid-template: calc(var(--nav-height) - 4px) 1fr / auto auto;
  }
`;

export const StyledLogo = styled(Logo)`
  height: 100%;
  overflow: visible;
  width: auto;
  margin-left: var(--nav-padding);

  ${media.down("TABLET")` 
    width: 88px;
  `}
`;
